module.exports = __webpack_public_path__ + "img/image-12@3x.83d49a00.png";